<template>
  <div>
    <div class="index-head pic-wrap">
      <img src="../assets/img/index-1.jpg" class="index-pic">
      <button class="index-head-btn_record" @click="searchRecord">订单查询</button>
    </div>
    <div class="index-main pic-wrap">
      <img src="../assets/img/index-2.jpg" class="index-pic">
      <button class="index-main-btn_submit" @click="submitEvent" v-if="showProgress">立即享受</button>
      <Progress :rate="rate" v-if="showProgress"></Progress> 
      <p class="index-main-phone" v-if="cachePhone">
        <span class="phone">{{cachePhone}}</span>
        <span class="index-main-phone-btn" @click="outLogin">退出</span>
      </p>
    </div>
    <div class="index-bottom pic-wrap">
      <img src="../assets/img/index-3.jpg" class="index-pic">
    </div>
    <keep-alive>
      <Dialog v-if="dialogType" :dialogType="dialogType">
        <!-- <login-form @loginSuccess="loginSuccess"></login-form> -->
      </Dialog>
    </keep-alive>
  </div>
</template>

<script>
// 18800001805
  import Progress from '../components/Progress'
  import Store from '../utils/store'
  import qs from 'qs'
  export default {
    components: {
     Progress,
     Dialog: () => import('../components/Dialog'),
    //  LoginForm
    },
    data () {
      return {
        rate: '0',
        dialogType: '',
        productInfo: null,
        showProgress: true
      }
    },
    computed: {
      cachePhone () {
        return Store.userInfo && Store.userInfo.phone
      }
    },
    mounted () {
      this.getLoginExt()
      this.querySkuList()
      this.judgePayState()
    },
    methods: {
      // 获取加密串
      getLoginExt () {
        const { CCBSIGN, CCBTIMESTAMP, ccbRemark1='', user_id} = qs.parse(window.location.search.slice(1))
        if (CCBSIGN && CCBTIMESTAMP && user_id) {
          this.loginExt = { CCBSIGN, CCBTIMESTAMP, ccbRemark1, user_id}
        }
      },
      judgePayState () {
        const {state = ''} = qs.parse(window.location.search.slice(1))
        if (state === 'success') {
          this.dialogType = 'paySuccess'
        } else if (state === 'fail') {
          this.dialogType = 'payFail'
        }
      },
      outLogin () {
        Store.setUserInfo(null)
      },
      querySkuList (userId='') {
        this.$http.querySkuList({userId}).then(({data}) => {
          // item.rate -> 库存  Math.ceil((1 - item.rate) * 100).toFixed(0)}
          // "skuDiscFee" : "0", // 无促销优惠
          if (data.success && data.datas && data.datas.length) {
            // 活动未开始/已结束 1已使用，6未开始，7过期，9禁用
            if (data.datas[0].state !== '1') {
              this.judgeActivityTimeState(data.datas[0].state)
              return
            }
            const { skuList } = data.datas[0]
            if (!skuList.length) return
            const { salePrice, configSkuDiscFee, rate } = skuList[0] 
            if (!userId) {
              if (salePrice * 1 - configSkuDiscFee * 1 > 0 ) {
                this.hasDisc = true
                this.rate = Math.ceil((1 - rate) * 100).toFixed(0) 
              }
            } else { // 第二次传（有useId的情况）
              if ((skuList[0].skuDiscFee * 1 > 0) && (Math.ceil((1 - skuList[0].rate) * 100).toFixed(0) > 0)) {
              // if ( this.hasDisc && (this.rate * 1 > 0)) {
                this.productInfo = skuList[0] 
                this.dialogType = 'verifySuccess'   
              } else {
                this.dialogType = 'verifyAlready'
              }
            }
          } else {
            this.$tip('数据异常，请稍后重试')
          }
        }).catch(e => {
          if (/403/.test(e)) {
            this.showProgress = false
            this.dialogType = 'tooHot'
          }
        })
      },
      judgeActivityTimeState (state) {
        if (state === '6') { // 活动未开始
          this.dialogType = 'notBegin'
          this.activityTimeType = 'notBegin'
        } else if (state === '7') { // 活动已过期
          this.dialogType = 'expired'
          this.activityTimeType = 'expired'
        }
      },
      // 按钮点击 
      async submitEvent () {
        if (!this.loginExt) {
          this.dialogType = 'bankLogin'
          return
        }
        if (this.activityTimeType) { // 活动未开始/已结束
          this.dialogType = this.activityTimeType
          return
        }
        if (window.errMsg) {
          this.$tip(window.errMsg)
          return
        }
        if (this.rate * 1 > 0) {
          // if (this.userInfo.token) {
          if (Store.userInfo.token) {
            this.collectUserAction()
          } else {
            this.$login.show(() => {
              this.collectUserAction()
            }, this.loginExt, false)
            // this.dialogType = 'login'
          }
        } else {
          this.$tip('抱歉！您来晚啦，商品已经抢完了~')
        }
      },
      searchRecord () {
        if (!Store.userInfo.token) {
          this.$login.show(null, this.loginExt, false)
        } else {
          this.$router.push('record')
        }
      },
      async collectUserAction () {
        if (!this.loginExt) {
          this.dialogType = 'bankLogin'
          return
        }
        const { CCBSIGN: ccbSign, CCBTIMESTAMP: ccbTimeStamp, ccbRemark1, user_id: ccbUserId } = this.loginExt

        this.$http.collectUserAction({
          myAuthToken: Store.userInfo.token,
          userId: Store.userInfo.userId,
          ccbTimeStamp,
          ccbSign,
          ccbRemark1,
          ccbUserId

        }).then(({data}) => {
          if (data.success || data.errorCode === '400030' || data.errorCode === '400032') { // 查询促销，成功或者超过次数限制，不做处理
            this.querySkuList(Store.userInfo.userId) 
          } else if (data.errorCode === '432002' || data.errorCode === '450001') { // 白名单校验不通过
            this.dialogType = 'verifyFail'
          } else if (data.errorCode === '410015') { // 登录过期
            // this.$tip('登录失效，请重新登录')
            this.$login.show(() => {
              this.collectUserAction()
            }, this.loginExt)
          } else if (data.errorCode === '432003' || data.errorCode === '432001') {
            // app加密串校验
            this.dialogType = 'bankLogin'
            this.bankLoginFail = true
          } else {
            this.dialogType = 'verifyAlready'
          }
        })
      },
      pay (phone) {
        // 缓存充值手机号
        this.cachePhone = phone
        const url = location.origin + location.pathname
        this.$http.placeorder({
          skuId: this.productInfo.skuId,
          payReturnUrl: url + '?state=success',
          unpayReturnUrl: url + '?state=fail',
          authId: Store.userInfo.userId,
          phone,
          authToken: Store.userInfo.token,
          loginUserId: Store.userInfo.userId
        }).then(({ data }) => {
          if (data.success) {
            const { datas } = data
            if (!datas.login) { // 登录失效
              // this.$tip('登录信息失效，请重新登录！')
              // this.dialogType = 'login'
              this.$login.show(() => {
                this.pay(this.cachePhone)
              }, this.loginExt)
              return
            } 
            if (datas.couponAmount <= 0) {
              this.$tip('太多人抢啦，请稍后再试~')              
              setTimeout(() => {
                window.location.reload()
              }, 3000)
              return
            }
            window.location.href = datas.payStr
          }
        }).catch(e => {
          if (/403/.test(e)) {
            this.dialogType = 'tooHot'
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.pic-wrap {
  font-size: 0;
  position: relative;
}
.index-pic { 
  width: 100%;
  height: auto;
}
.index-head-btn_record {
  position: absolute;
  right: 0;
  top: 70px;
  width: 211px;
	height: 60px;
	background-color: rgba(0,0,0,0.2);
	border-radius: 30px 0 0 30px;
  // opacity: 0.2;
  font-size: 36px;
  color: #27cbff;
}
.index-main {
  margin-top: -1px;
  position: relative;
  &-phone {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 220px;
    color: #fff;
    font-size: 45px;
    text-align: center;
    .phone {
      font-weight: bold;
    }
    &-btn {
      font-size: 43px;
      color: #f3e743;
      text-decoration: underline;
      position: relative;
      left: 38px;
    }
  }
}
.index-main-btn_submit {
  &:active {
    box-shadow: initial;
  }
  position: absolute;
  top: 145px;
  left: 0;
  right: 0;
  margin: auto;
  width: 540px;
  height: 122px;
  border-radius: 65px;
  background-color: #ffd016;
  box-shadow: 0px 15px 15px 0px 
    rgba(131, 19, 17, 0.43);
  font-size: 60px;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #c20000;
  transform: all 0.2s;
  &::before {
    content: '';
    width: 582px;
    height: 91px;
    background: url('../assets/img/light-btn.png') 0 0 / 100% 100% no-repeat;
    position: absolute;
    top: -40px;
    left: 50%;
    margin-left: -291px;
  }
    
}
</style>